import { Layout } from "@/Layout"
import React from "react"

export const Security = () => {
  return (
    <Layout headerTheme={"White"} footerTheme={"White"} withHeader={true}>
      <div className="Rates">
        <div className="Container">
          <h1 className="Rates__Title-H1 Title Title--H1">Security</h1>
          <p>Coming soon.</p>
        </div>
      </div>
    </Layout>
  )
}
